import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState } from '../../stores/types/types';
import * as SessionActions from '../../stores/actions/session';
import * as OpenTokActions from '../../stores/actions/opentok';
import { HELP_SUBMENU } from '../../stores/reducers/session';
import Link from '../general-components/link';
import * as ModalActions from '../../stores/actions/modal';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';

interface HelpMenuProps {
	onClose: () => void;
}

export default function HelpMenu(props: HelpMenuProps) {
	const host = useSelector((state: GreenroomState) => state.SessionReducer.host);
	const showDebugUI = useSelector((state: GreenroomState) => state.OpenTokReducer.showDebugUI);

	const { onClose } = props;

	const dispatch = useDispatch();

	const setSubmenu = (submenu: string) => {
		dispatch(SessionActions.setActiveHelpSubmenu(submenu));
	};

	const showTutorialVideo = () => {
		dispatch(ModalActions.setModalState({
			modalOpen: true,
			modalTemplate: MODAL_TEMPLATES.HELP_MENU_TUTORIAL_VIDEO,
		}));
		onClose();
	};

	const showOpenTokDebugUI = () => {
		dispatch(OpenTokActions.setShowDebugUI(!showDebugUI));
		onClose();
	};

	return (
		<div className="help-menu">
			<button onClick={showTutorialVideo}>
				Getting Started
			</button>
			<Link
				title='Help Center'
				url='https://help.brand.live/hc/en-us/categories/1500000024001-Greenroom'
				customClass='link-button'
				onClick={onClose}
			/>
			<button onClick={() => setSubmenu(HELP_SUBMENU.SUPPORT)}>
				Brandlive Support
			</button>
			<Link
				title='Release Notes'
				url='https://www.brandlive.com/whats-new?utm_campaign=Brandlive%20External%20Comms&utm_source=Greenroom&utm_medium=Help%20Center%20Menu'
				customClass='link-button'
				onClick={onClose}
			/>
			<button onClick={() => setSubmenu(HELP_SUBMENU.KEYBOARD_SHORTCUTS)}>
				Keyboard Shortcuts
			</button>
			<Link
				title='Brandlive Academy'
				url={host
					? 'https://enablement.brandlive.com/Brandlive-Academy/en/home'
					: 'https://enablement.brandlive.com/Brandlive-Academy/en/session/5190e880-7feb-11ed-ad16-e7223891061d'
				}
				customClass='link-button'
				onClick={onClose}
			/>
			{host && <button onClick={showOpenTokDebugUI}>Troubleshoot Video</button>}
		</div>
	);
}
